import Swal from "sweetalert2";

const SweetAlert = ({ title, text, icon, onConfirm }) => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonText: "OK",
  }).then(onConfirm);

  return null;
};

export default SweetAlert;
